import { render, staticRenderFns } from "./educationImp.vue?vue&type=template&id=0b90963f&"
import script from "./educationImp.vue?vue&type=script&lang=js&"
export * from "./educationImp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports